export default "__VITE_ASSET__Cs2BM52m__"